import { render, staticRenderFns } from "./OnboardingBackAndForth.vue?vue&type=template&id=411709ad&lang=pug"
import script from "./OnboardingBackAndForth.vue?vue&type=script&lang=js"
export * from "./OnboardingBackAndForth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports